import { Plus } from 'lucide-react';
import React from 'react';
import { Button, Tooltip } from '../ui';
import GenerateForm from './GenerateForm';
import FormDrawer from '../ui/FormDrawer';

export default function Generate(props: { handleFunction: any }) {
    const [open, setOpen] = React.useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <Tooltip title="Générer des tickets">
                <Button
                    size='sm'
                    className="float-right"
                    variant="primary"
                    startIcon={<Plus size={16} />}
                    onClick={() => setOpen(true)}
                >Générer</Button>
            </Tooltip>
            <FormDrawer
                open={open}
                onClose={handleClose}
                title="Nouvelle file d'attente"
                hint="Paramétrez la génération des tickets de la file d'attente."
            >
                <GenerateForm handleFunction={() => { handleClose(); props.handleFunction(); }} />
            </FormDrawer>
        </div>
    );
}
